import { render, staticRenderFns } from "./BtnToDocumentacao.vue?vue&type=template&id=81bdcfc6"
import script from "./BtnToDocumentacao.vue?vue&type=script&lang=js"
export * from "./BtnToDocumentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports